import { render } from "./Phases.vue?vue&type=template&id=3dfe2678&scoped=true"
import script from "./Phases.vue?vue&type=script&lang=js"
export * from "./Phases.vue?vue&type=script&lang=js"

import "./Phases.vue?vue&type=style&index=0&id=3dfe2678&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/ecstatic-ride.91-210-227-178.plesk.page/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfe2678"]])

export default __exports__